import React from 'react';
import ReactDOM from 'react-dom';
import { Widget } from './Widget';
window.__ET_VERSION = process.env.GITHUB_RUN_NUMBER + "-" + process.env.GITHUB_SHA;
var widgetRoot = document.createElement('div');
document.body.appendChild(widgetRoot);
ReactDOM.render(React.createElement(Widget, null), widgetRoot);
